import React from 'react';
import {withStyles, Tab, createStyles} from '@material-ui/core';
import {Theme} from '@material-ui/core/styles';

interface StyledTabProps {
  label: string;
}
const StyledTab = withStyles((theme: Theme) =>
  createStyles({
    root: {
      textTransform: 'none',
      fontWeight: theme.typography.fontWeightMedium as number,
      fontSize: '1.1rem',
      color: theme.palette.common.white,
      marginRight: theme.spacing(1),
      opacity: 1,
      '& .focus': {
        color: theme.palette.common.white
      }
    },
    selected: {
      fontSize: '1.1rem',
      fontWeight: 500,
      color: theme.palette.common.white
    }
  })
)((props: StyledTabProps) => <Tab {...props} />);

export default StyledTab;
